import { render, staticRenderFns } from "./FAQManagement.vue?vue&type=template&id=31e81de6&scoped=true&"
import script from "./FAQManagement.vue?vue&type=script&lang=js&"
export * from "./FAQManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e81de6",
  null
  
)

export default component.exports